/**
 * Screen 11 - display results
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';
import ResultsActionStep from './ResultsActionStep';
import ResultsOverlay from './ResultsOverlay';
import ResultsSection from './ResultsSection';

function Results({
  clearGoalResults,
  emailResults,
  emailSent,
  monitorInterval,
  myAccountablePerson,
  myActionSteps,
  myAffirmation,
  myChallengePlan,
  myChallenges,
  myGoal,
  myReadingList,
  paragraphData,
  resultCategory,
  resultHowSoonText,
  resultsOverlay,
  resultUserEmail,
  setResult,
}) {
  const { fieldTitle } = paragraphData;
  const actionSteps = myActionSteps.map((step, index) =>
    <ResultsActionStep key={`action-step-${index}`} step={step} />,
  );
  const myFirstSteps = (
    <div>
      {actionSteps}
    </div>
  );
  const renderedReadingList = (
    <div>
      <div>
        Get informed to help you stay on track.
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: myReadingList ? myReadingList[0].fieldReadingList : '',
        }}
      />
    </div>
  );
  const onClick = () => setResult({ resultsOverlay: true });
  const forCategory = resultCategory ? `for ${resultCategory.name}` : '';
  const showResults = 'Results are available for 45 minutes unless you close the browser or click "Create a new goal".';
  return (
    <div
      className={classnames({
        'goal--step-eleven': true,
      })}
    >
      {resultsOverlay ?
        <ResultsOverlay
          emailResults={emailResults}
          emailSent={emailSent}
          resultUserEmail={resultUserEmail}
          setResult={setResult}
        />
        :
          <div>
            <h1>
              Your results {forCategory}
            </h1>
            <div
              className={classnames({
                'no-print': true,
              })}
              style={{
                fontSize: '16px',
                color: '#aaa',
                margin: '-20px 0 5px',
              }}
            >
              {showResults}
            </div>
            <h4
              dangerouslySetInnerHTML={{
                __html: fieldTitle[0] ? fieldTitle[0].value : '',
              }}
              style={{
                margin: '15px 0',
              }}
            />
            <div
              className={classnames({
                'no-print': true,
              })}
              style={{
                borderBottom: '1px solid rgb(200, 200, 200)',
                paddingBottom: '5px',
                marginBottom: '10px',
              }}
            >
              <button onClick={onClick}>
                Email Results
              </button>
              <button onClick={() => print()}>
                Print Results
              </button>
              <button onClick={clearGoalResults}>
                Create a new goal
              </button>
            </div>
            <ResultsSection title="My goal:" content={myGoal} />
            <ResultsSection title="I am aiming to achieve my goal by:" content={resultHowSoonText} />
            <ResultsSection title="I will check my progress toward my goal:" content={monitorInterval} />
            <ResultsSection title="My challenges are:" content={myChallenges} />
            <ResultsSection title="My plan for dealing with challenges:" content={myChallengePlan} />
            <ResultsSection title="My encouraging message to myself:" content={myAffirmation} />
            <ResultsSection title="My first step(s):" content={myFirstSteps} />
            <ResultsSection title="My accountability partner:" content={myAccountablePerson} />
            <ResultsSection title="Your reading list" content={renderedReadingList} />
          </div>
      }
    </div>
  );
}

Results.propTypes = {
  clearGoalResults: PropTypes.func,
  emailResults: PropTypes.func,
  emailSent: PropTypes.bool,
  monitorInterval: PropTypes.string,
  myAccountablePerson: PropTypes.string,
  myActionSteps: PropTypes.arrayOf(PropTypes.shape({})),
  myAffirmation: PropTypes.string,
  myChallengePlan: PropTypes.string,
  myChallenges: PropTypes.string,
  myGoal: PropTypes.string,
  myReadingList: PropTypes.arrayOf(PropTypes.shape({})),
  paragraphData: PropTypes.shape({}),
  resultCategory: PropTypes.shape({}),
  resultHowSoonText: PropTypes.string,
  resultsOverlay: PropTypes.bool,
  resultUserEmail: PropTypes.string,
  setResult: PropTypes.func,
};

export default Results;



// WEBPACK FOOTER //
// js/src/goals/Results.js